/**
 * Shared EXISTING/NEW record table styles — racks (#995) + repeatable instances (#1154).
 */

import { Platform, StyleSheet } from 'react-native';

import { colors } from '../../theme';

export const RECORD_TABLE_ACTIONS_COLUMN_WIDTH = 44;

export const recordTableStyles = StyleSheet.create({
  headerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: 40,
    backgroundColor: colors.backgroundMuted,
    borderBottomWidth: 1,
    borderBottomColor: colors.borderCard,
    ...Platform.select({
      web: {
        width: '100%',
        alignSelf: 'stretch',
      },
    }),
  },
  headerRowCompact: {
    minHeight: 34,
  },
  headerBarSpacer: {
    width: 5,
    flexShrink: 0,
  },
  headerDragSpacer: {
    width: 28,
    flexShrink: 0,
  },
  headerCell: {
    minWidth: 0,
    justifyContent: 'center',
  },
  compactHeaderCell: {
    minWidth: 0,
    justifyContent: 'center',
  },
  headerCellStart: {
    alignItems: 'flex-start',
  },
  headerCellCenter: {
    alignItems: 'center',
  },
  headerText: {
    fontSize: 11,
    fontWeight: '600',
    letterSpacing: 0.5,
    color: colors.textSecondary,
    textTransform: 'uppercase',
    flexShrink: 1,
    ...Platform.select({
      web: {
        maxWidth: '100%',
        whiteSpace: 'nowrap' as const,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    }),
  },
  headerTextCompact: {
    fontSize: 9,
    letterSpacing: 0.35,
  },
  headerTextCenter: {
    textAlign: 'center',
    width: '100%',
  },
  headerActionsSpacer: {
    width: RECORD_TABLE_ACTIONS_COLUMN_WIDTH,
    flexShrink: 0,
  },
  headerActionsSpacerCompact: {
    width: 36,
  },
  headerActionsSpacerHidden: {
    width: 0,
    display: 'none' as unknown as undefined,
  },
  tableCell: {
    paddingVertical: 14,
    minWidth: 0,
    gap: 2,
  },
  compactTableCell: {
    paddingVertical: 10,
    minWidth: 0,
    gap: 1,
  },
  tableCellStart: {
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  tableCellCenter: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  tableCellText: {
    fontSize: 13,
    fontWeight: '400',
    color: colors.textSecondary,
  },
  tableCellTextCenter: {
    textAlign: 'center',
    width: '100%',
  },
  compactCellText: {
    fontSize: 12,
  },
  modelPrimaryText: {
    fontSize: 13,
    fontWeight: '700',
    color: colors.textPrimary,
  },
  modelSublineText: {
    fontSize: 12,
    fontWeight: '400',
    color: colors.textSecondary,
  },
  compactPrimaryText: {
    fontSize: 12,
  },
  compactSublineText: {
    fontSize: 11,
  },
  placeholderText: {
    fontWeight: '400',
    fontStyle: 'italic',
    color: colors.textMuted,
  },
  placeholderMuted: {
    color: colors.textMuted,
  },
});

export type RecordTableColumnAlign = 'left' | 'center';

export type RecordTableLayout = 'desktop' | 'compact';

export function resolveRecordTableColumnAlign(
  columnAlign: RecordTableColumnAlign | undefined,
): RecordTableColumnAlign {
  return columnAlign ?? 'left';
}
